
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nscc1fcca4c48948e4afaa13e5a72f661een from './en.yaml'
            i18n.addResourceBundle('en', 'cc1fcca4c48948e4afaa13e5a72f661e', flattenObject(nscc1fcca4c48948e4afaa13e5a72f661een), true, true);
        
        export default 'cc1fcca4c48948e4afaa13e5a72f661e';
    